angular.module('impactx.approval').controller('ApprovalStatusCtrl', [
    'AppConfiguration',
    '$scope',
    ApprovalStatusCtrl
]);

function ApprovalStatusCtrl(AppConfiguration, $scope) {
    var ctrl = this;
    ctrl.hideApprovalWorkflowPanel = AppConfiguration.get('HideApprovalWorkflowPanel');

    $scope.show = $scope.viewToggle ? !!$scope.viewInitial : true;

    ctrl.deleteApprover = function(entry, indedx) {
        // noop
    }

    ctrl.toggleView = function () {
        $scope.show = !$scope.show
    }

    ctrl.canRedirectAny = function (step) {
        for (var i = 0; i < step.setEntries.length; i++) {
            var entry = step.setEntries[i];
            if (entry.user && entry.canRedirect) {
                return true;
            }
            else if (entry.group) {
                var canRedirectAnyInGroup = entry.group.setEntries.filter(function (entry) {
                    return entry.canRedirect;
                }).length > 0;
                if (canRedirectAnyInGroup) {
                    return true;
                }
            }
        }
        return false;
    }
}